export default __webpack_public_path__ + "static/media/Huang.c511d98a.png";